var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"item",class:{ active: _vm.active, rounded: _vm.rounded, small: _vm.small, large: _vm.large, bordered: _vm.bordered }},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }